<template>
  <div>
    <v-tooltip
      top
      max-width="260px"
      content-class="light-tooltip"
    >
      <template #activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          @click="onClick"
        >
          <span
            class="rounded-circle border d-inline-block d-flex justify-content-center align-items-center info-text font-9"
            :class="{
              'white' : (module.module_progress >= 100 && cycle.is_current) && !module.disabled,
              'border-gray-400' : module.disabled,
              'border-nitro' : !module.disabled,
              'nitro' : !module.disabled && (module.module_progress >= 100 || module.finished_at),
            }"
            style="width: 33px; height: 33px; cursor: pointer;"
          >
            <p
              class="text-center font-weight-semibold p-0 m-0 font-9"
              :class="{
                'white--text' : !module.disabled && (module.module_progress >= 100 || module.finished_at),
                'nitro--text' : !module.disabled && (module.module_progress < 100 || !module.finished_at),
                'gray-400--text' : module.disabled
              }"
            >
              {{ module.module_progress }}%
            </p>
          </span>
          <p
            class="text-center font-weight-bold font-9 m-0"
            :class="{
              'nitro--text' : !module.disabled,
              'gray-400--text' : module.disabled
            }"
          >
            M{{ module.module_order }}
          </p>
        </div>
      </template>
      <span v-if="module.disabled">
        <p class="text-center m-0 font-11">
          O módulo ainda não está disponível. Aguarde a liberação no dia {{ $moment(module.begin_date).format('DD/MM/YYYY [às] hh:mm') }}
        </p>
      </span>
      <span v-else>
        <p class="font-12 font-weight-semibold m-0">
          {{ module.block_id ? module.block.name : module.subject_acronym }} | <span>{{ module.name }}</span>
        </p>
        <p class="font-11 font-weight-semibold m-0">
          <img
            src="/images/tooltip_module_gray_icons/local.png"
            class="img-icon"
          >  Módulo <span v-if="module.finished_at">finalizado</span><span v-else>liberado</span>
        </p>
        <p class="m-0 font-11 font-weight-regular">
          <img
            src="/images/tooltip_module_gray_icons/calendar.svg"
            class="img-icon"
          > Janela: <span> {{ $moment(module.begin_date).format('DD/MM') }} a {{ $moment(module.end_date).format('DD/MM') }}</span>
        </p>
        <p class="m-0 font-11 font-weight-regular">
          <img
            src="/images/tooltip_module_gray_icons/progress.svg"
            class="img-icon"
          > Progresso geral: <span> {{ module.module_progress }}%</span>
        </p>
        <p class="m-0 font-11 font-weight-regular">
          <img
            src="/images/tooltip_module_gray_icons/check.svg"
            class="img-icon"
          > Conteúdos concluídos: <span> {{ module.count_completed_contents }} / {{ module.count_contents }}</span>
        </p>
      </span>
    </v-tooltip>
  </div>    
</template>
<script>
import { showModuleRouteName } from '@/student/constants/routes';

export default {
    props: {
        module: {
            type:Object,
            required:true,
        },
        cycle: {
            type:Object,
            required:true,
        }
    },
    data(){
        return {
            showModuleRouteName
        }
    },
    methods: {
      onClick(){
        if(!this.module.disabled){
          this.$router.push( { name: showModuleRouteName, params: { module_id: this.module.id }})
        }
      }
    }
}
</script>
<style lang="scss">
.custom-tooltip {
   opacity: 1 !important;
  background-color: #f0f0f5 !important;
  color: #828282 !important;
}
.img-icon{
  width: 14px;
  height: 14px;
}
</style>